import { PropType } from 'vue';
import { Options, Vue } from 'vue-class-component';
import DialogConfirmDelete from '@/views/components/DialogConfirmDelete/DialogConfirmDelete.vue';
import { SwitchboardDTO } from 'client-generator/generated-clients/plants';

@Options({
  name: 'SwitchboardItem',
  props: {
    switchboard: {
      type: Object as PropType<SwitchboardDTO>,
      required: true,
    },
    disableOptions: {
      type:Boolean,
      required: false,
      default:false
    }
  },
  components: {
    DialogConfirmDelete,
  },
  emits: ['delete-switchboard', 'edit-switchboard'],
})
export default class SwitchboardItem extends Vue {
  switchboard!: SwitchboardDTO;
  isVisibleDeleteSwitchboardConfirm = false; 
  disableOptions!:boolean;

  toggleDeleteSwitchboardConfirm(){
    this.isVisibleDeleteSwitchboardConfirm = !this.isVisibleDeleteSwitchboardConfirm;
  }

  async handleDeleteSwitchboard() {
    this.$emit('delete-switchboard', this.switchboard);
  }

  async handleEditSwitchboard() {
    this.$emit('edit-switchboard', this.switchboard);
  }
}
